var _rect, _g, _defs;

var _excluded = ["title", "titleId"];

function _extends() { _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }

function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }

function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }

import * as React from "react";

function SvgInfoIcon(_ref, svgRef) {
  var title = _ref.title,
      titleId = _ref.titleId,
      props = _objectWithoutProperties(_ref, _excluded);

  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 14,
    height: 14,
    viewBox: "0 0 14 14",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _rect || (_rect = /*#__PURE__*/React.createElement("rect", {
    width: 14,
    height: 14,
    fill: "#F5F5F5"
  })), _g || (_g = /*#__PURE__*/React.createElement("g", {
    id: "Verification Modals"
  }, /*#__PURE__*/React.createElement("rect", {
    width: 6912,
    height: 1638,
    transform: "translate(-826 -803)",
    fill: "white"
  }), /*#__PURE__*/React.createElement("g", {
    id: "Verified proof",
    clipPath: "url(#clip0_0_1)"
  }, /*#__PURE__*/React.createElement("rect", {
    width: 1440,
    height: 1024,
    transform: "translate(-536 -496)",
    fill: "#003DA6"
  }), /*#__PURE__*/React.createElement("g", {
    id: "Group 80"
  }, /*#__PURE__*/React.createElement("rect", {
    id: "Rectangle Copy",
    x: -382,
    y: -101,
    width: 1246,
    height: 318,
    rx: 20,
    fill: "#0A337A"
  })), /*#__PURE__*/React.createElement("g", {
    id: "Group 682"
  }, /*#__PURE__*/React.createElement("g", {
    id: "Group 7 Copy 6",
    clipPath: "url(#clip1_0_1)"
  }, /*#__PURE__*/React.createElement("circle", {
    id: "Oval",
    cx: -56,
    cy: 74,
    r: 80,
    fill: "#4653F6"
  }))), /*#__PURE__*/React.createElement("rect", {
    id: "Rectangle 195",
    opacity: 0.9,
    x: -536,
    y: -496,
    width: 1440,
    height: 1457,
    fill: "#00154F"
  }), /*#__PURE__*/React.createElement("g", {
    id: "Group 724"
  }, /*#__PURE__*/React.createElement("g", {
    id: "Group 77"
  }, /*#__PURE__*/React.createElement("g", {
    id: "Components / Modal Base Copy",
    clipPath: "url(#clip2_0_1)",
    filter: "url(#filter0_ddd_0_1)"
  }, /*#__PURE__*/React.createElement("g", {
    id: "BG",
    filter: "url(#filter1_dd_0_1)"
  }, /*#__PURE__*/React.createElement("rect", {
    x: -88,
    y: -249,
    width: 544,
    height: 530,
    rx: 14,
    fill: "white"
  })))), /*#__PURE__*/React.createElement("g", {
    id: "Group 726"
  }, /*#__PURE__*/React.createElement("g", {
    id: "Group 725"
  }, /*#__PURE__*/React.createElement("g", {
    id: "Group 711"
  }, /*#__PURE__*/React.createElement("g", {
    id: "Text-field/Box Copy 11",
    clipPath: "url(#clip3_0_1)"
  })), /*#__PURE__*/React.createElement("g", {
    id: "mdi:help-circle-outline"
  }, /*#__PURE__*/React.createElement("path", {
    id: "mdi:help-circle-outline_2",
    d: "M6.4165 10.5003H7.58317V9.33366H6.4165V10.5003ZM6.99984 1.16699C6.23379 1.16699 5.47525 1.31788 4.76752 1.61103C4.05978 1.90418 3.41672 2.33386 2.87505 2.87554C1.78109 3.9695 1.1665 5.45323 1.1665 7.00033C1.1665 8.54742 1.78109 10.0312 2.87505 11.1251C3.41672 11.6668 4.05978 12.0965 4.76752 12.3896C5.47525 12.6828 6.23379 12.8337 6.99984 12.8337C8.54693 12.8337 10.0307 12.2191 11.1246 11.1251C12.2186 10.0312 12.8332 8.54742 12.8332 7.00033C12.8332 6.23428 12.6823 5.47574 12.3891 4.76801C12.096 4.06027 11.6663 3.41721 11.1246 2.87554C10.583 2.33386 9.93989 1.90418 9.23216 1.61103C8.52442 1.31788 7.76588 1.16699 6.99984 1.16699ZM6.99984 11.667C4.42734 11.667 2.33317 9.57283 2.33317 7.00033C2.33317 4.42783 4.42734 2.33366 6.99984 2.33366C9.57234 2.33366 11.6665 4.42783 11.6665 7.00033C11.6665 9.57283 9.57234 11.667 6.99984 11.667ZM6.99984 3.50033C6.381 3.50033 5.78751 3.74616 5.34992 4.18374C4.91234 4.62133 4.6665 5.21482 4.6665 5.83366H5.83317C5.83317 5.52424 5.95609 5.22749 6.17488 5.0087C6.39367 4.78991 6.69042 4.66699 6.99984 4.66699C7.30926 4.66699 7.606 4.78991 7.82479 5.0087C8.04359 5.22749 8.1665 5.52424 8.1665 5.83366C8.1665 7.00033 6.4165 6.85449 6.4165 8.75033H7.58317C7.58317 7.43783 9.33317 7.29199 9.33317 5.83366C9.33317 5.21482 9.08734 4.62133 8.64975 4.18374C8.21217 3.74616 7.61868 3.50033 6.99984 3.50033Z",
    fill: "#00ADBB"
  })))))))), _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("filter", {
    id: "filter0_ddd_0_1",
    x: -123,
    y: -278,
    width: 614,
    height: 601,
    filterUnits: "userSpaceOnUse",
    colorInterpolationFilters: "sRGB"
  }, /*#__PURE__*/React.createElement("feFlood", {
    floodOpacity: 0,
    result: "BackgroundImageFix"
  }), /*#__PURE__*/React.createElement("feColorMatrix", {
    in: "SourceAlpha",
    type: "matrix",
    values: "0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 127 0",
    result: "hardAlpha"
  }), /*#__PURE__*/React.createElement("feMorphology", {
    radius: 5,
    operator: "dilate",
    in: "SourceAlpha",
    result: "effect1_dropShadow_0_1"
  }), /*#__PURE__*/React.createElement("feOffset", {
    dy: 6
  }), /*#__PURE__*/React.createElement("feGaussianBlur", {
    stdDeviation: 15
  }), /*#__PURE__*/React.createElement("feComposite", {
    in2: "hardAlpha",
    operator: "out"
  }), /*#__PURE__*/React.createElement("feColorMatrix", {
    type: "matrix",
    values: "0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0.12 0"
  }), /*#__PURE__*/React.createElement("feBlend", {
    mode: "normal",
    in2: "BackgroundImageFix",
    result: "effect1_dropShadow_0_1"
  }), /*#__PURE__*/React.createElement("feColorMatrix", {
    in: "SourceAlpha",
    type: "matrix",
    values: "0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 127 0",
    result: "hardAlpha"
  }), /*#__PURE__*/React.createElement("feMorphology", {
    radius: 2,
    operator: "dilate",
    in: "SourceAlpha",
    result: "effect2_dropShadow_0_1"
  }), /*#__PURE__*/React.createElement("feOffset", {
    dy: 16
  }), /*#__PURE__*/React.createElement("feGaussianBlur", {
    stdDeviation: 12
  }), /*#__PURE__*/React.createElement("feComposite", {
    in2: "hardAlpha",
    operator: "out"
  }), /*#__PURE__*/React.createElement("feColorMatrix", {
    type: "matrix",
    values: "0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0.14 0"
  }), /*#__PURE__*/React.createElement("feBlend", {
    mode: "normal",
    in2: "effect1_dropShadow_0_1",
    result: "effect2_dropShadow_0_1"
  }), /*#__PURE__*/React.createElement("feColorMatrix", {
    in: "SourceAlpha",
    type: "matrix",
    values: "0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 127 0",
    result: "hardAlpha"
  }), /*#__PURE__*/React.createElement("feMorphology", {
    radius: 5,
    operator: "erode",
    in: "SourceAlpha",
    result: "effect3_dropShadow_0_1"
  }), /*#__PURE__*/React.createElement("feOffset", {
    dy: 8
  }), /*#__PURE__*/React.createElement("feGaussianBlur", {
    stdDeviation: 5
  }), /*#__PURE__*/React.createElement("feComposite", {
    in2: "hardAlpha",
    operator: "out"
  }), /*#__PURE__*/React.createElement("feColorMatrix", {
    type: "matrix",
    values: "0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0.2 0"
  }), /*#__PURE__*/React.createElement("feBlend", {
    mode: "normal",
    in2: "effect2_dropShadow_0_1",
    result: "effect3_dropShadow_0_1"
  }), /*#__PURE__*/React.createElement("feBlend", {
    mode: "normal",
    in: "SourceGraphic",
    in2: "effect3_dropShadow_0_1",
    result: "shape"
  })), /*#__PURE__*/React.createElement("filter", {
    id: "filter1_dd_0_1",
    x: -128,
    y: -259,
    width: 624,
    height: 610,
    filterUnits: "userSpaceOnUse",
    colorInterpolationFilters: "sRGB"
  }, /*#__PURE__*/React.createElement("feFlood", {
    floodOpacity: 0,
    result: "BackgroundImageFix"
  }), /*#__PURE__*/React.createElement("feColorMatrix", {
    in: "SourceAlpha",
    type: "matrix",
    values: "0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 127 0",
    result: "hardAlpha"
  }), /*#__PURE__*/React.createElement("feOffset", {
    dy: 30
  }), /*#__PURE__*/React.createElement("feGaussianBlur", {
    stdDeviation: 20
  }), /*#__PURE__*/React.createElement("feColorMatrix", {
    type: "matrix",
    values: "0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0.2 0"
  }), /*#__PURE__*/React.createElement("feBlend", {
    mode: "normal",
    in2: "BackgroundImageFix",
    result: "effect1_dropShadow_0_1"
  }), /*#__PURE__*/React.createElement("feColorMatrix", {
    in: "SourceAlpha",
    type: "matrix",
    values: "0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 127 0",
    result: "hardAlpha"
  }), /*#__PURE__*/React.createElement("feOffset", {
    dy: 2
  }), /*#__PURE__*/React.createElement("feGaussianBlur", {
    stdDeviation: 2
  }), /*#__PURE__*/React.createElement("feColorMatrix", {
    type: "matrix",
    values: "0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0.05 0"
  }), /*#__PURE__*/React.createElement("feBlend", {
    mode: "normal",
    in2: "effect1_dropShadow_0_1",
    result: "effect2_dropShadow_0_1"
  }), /*#__PURE__*/React.createElement("feBlend", {
    mode: "normal",
    in: "SourceGraphic",
    in2: "effect2_dropShadow_0_1",
    result: "shape"
  })), /*#__PURE__*/React.createElement("clipPath", {
    id: "clip0_0_1"
  }, /*#__PURE__*/React.createElement("rect", {
    width: 1440,
    height: 1024,
    fill: "white",
    transform: "translate(-536 -496)"
  })), /*#__PURE__*/React.createElement("clipPath", {
    id: "clip1_0_1"
  }, /*#__PURE__*/React.createElement("rect", {
    width: 160,
    height: 160,
    fill: "white",
    transform: "translate(-136 -6)"
  })), /*#__PURE__*/React.createElement("clipPath", {
    id: "clip2_0_1"
  }, /*#__PURE__*/React.createElement("rect", {
    width: 544,
    height: 530,
    fill: "white",
    transform: "translate(-88 -249)"
  })), /*#__PURE__*/React.createElement("clipPath", {
    id: "clip3_0_1"
  }, /*#__PURE__*/React.createElement("rect", {
    width: 480,
    height: 39,
    fill: "white",
    transform: "translate(-56)"
  })))));
}

var ForwardRef = /*#__PURE__*/React.forwardRef(SvgInfoIcon);
export default __webpack_public_path__ + "static/media/info_icon.9f96707ecb75d1e6038535d9ee01f7ee.svg";
export { ForwardRef as ReactComponent };